export default "__VITE_ASSET__DBr3n6fU__"